import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { Heading } from 'components'
import classes from './Contact.scss'
import { viewportWidth } from 'helpers/utilities'

// const LAT_LNG = '12.5892601,102.0803528'
// const API_KEY = 'AIzaSyBbHrVq6CTbwWQ6AJgx1tRnVWvallzEo9I'
// const staticMapURL = `https://maps.googleapis.com/maps/api/staticmap?center=${LAT_LNG}&zoom=17&size=390x565&maptype=roadmap&markers=color:red%7Clabel:ชัชชัย เภสัช%7C${LAT_LNG}&key=${API_KEY}`;

class Contact extends Component {
  componentDidMount () {
    window.objectFitImages()
  }

  render () {
    return (
      <section className={classes.contact}>
        <Helmet title='ติดต่อเรา' />
        <Heading>ติดต่อเรา</Heading>
        <div>
          <div className={`desktop ${classes.map}`}>
            <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3893.8936521605356!2d102.08035281481804!3d12.589260091107569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310481dacff5f955%3A0x71aa6f6ada5a755f!2zQ0NEQyDguKjguLnguJnguKLguYzguIHguKPguLDguIjguLLguKLguKrguLTguJnguITguYnguLLguIrguLHguIrguIrguLHguKLguYDguKDguKrguLHguIo!5e0!3m2!1sen!2sth!4v1503476210045'
              width='390' height='565' frameBorder='0' style={{ border: 0 }} allowFullscreen />
          </div>
          <div className={classes.contactInfo}>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-mobile.png' width='22' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>063-464-6194</p>
                <p>063-464-6195</p>
                <p>063-464-6196</p>
              </div>
            </div>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-line.png' width='25' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>@ccdc</p>
              </div>
            </div>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-facebook.png' width='10' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>www.facebook.com/chatchaibhaesaj</p>
              </div>
            </div>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-email.png' width='24' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>chatchaipharmacy@gmail.com</p>
              </div>
            </div>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-time.png' width='25' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>เวลาทำการ วันจันทร์ - วันเสาร์ เวลา 9.00 - 18.00 น.</p>
              </div>
            </div>
            <div className={classes.contactRow}>
              <div className={classes.contactCol}>
                <img src='/images/icon-location.png' width='15' role='presentation' />
              </div>
              <div className={classes.contactCol}>
                <p>1212/179 ถ.ท่าแฉลบ ต.ตลาด อ.เมือง จ.จันทบุรี 22000</p>
              </div>
            </div>
            <div className={`mobile ${classes.map}`}>
              <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3893.8936521605356!2d102.08035281481804!3d12.589260091107569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310481dacff5f955%3A0x71aa6f6ada5a755f!2zQ0NEQyDguKjguLnguJnguKLguYzguIHguKPguLDguIjguLLguKLguKrguLTguJnguITguYnguLLguIrguLHguIrguIrguLHguKLguYDguKDguKrguLHguIo!5e0!3m2!1sen!2sth!4v1503476210045'
                width={viewportWidth() - 20} height={(viewportWidth() - 20) * 1.4} frameBorder='0' style={{ border: 0 }} allowFullscreen />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/containers/User/Contact/Contact.js